import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { FormikContext } from 'formik';
import { useContext } from 'react';

type SubmitButtonProps = ButtonProps & {
  loading?: boolean;
};

const SubmitButton = ({
  loading = false,
  disabled,
  children,
  onClick,
  type = 'submit',
  sx,
  ...props
}: SubmitButtonProps) => {
  const formik = useContext(FormikContext);
  const isFormikSubmitting = Boolean(formik?.isSubmitting);
  const isLoading = loading || isFormikSubmitting;
  const hasValidationErrors = Boolean(
    formik && Object.keys(formik.errors || {}).length > 0,
  );

  return (
    <Button
      type={type}
      disabled={Boolean(disabled || isLoading || hasValidationErrors)}
      onClick={(event) => {
        if (isLoading) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        onClick?.(event);
      }}
      sx={{
        minHeight: '42px',
        ...sx,
      }}
      {...props}
    >
      {isLoading ? (
        <CircularProgress size={22} sx={{ color: 'inherit' }} />
      ) : (
        children
      )}
    </Button>
  );
};

export default SubmitButton;
